import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./ChatBot.css";

const ChatBot = () => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const { t, i18n } = useTranslation("global");
  const isRTL = i18n.language === "ar";

  const faqData = [
    {
      question: t("chatbot.questions.orderProduct"),
      answer: t("chatbot.questions.orderProductAnswer")
    },
    {
      question: t("chatbot.questions.paymentMethods"),
      answer: t("chatbot.questions.paymentMethodsAnswer")
    },
    {
      question: t("chatbot.questions.trackOrder"),
      answer: t("chatbot.questions.trackOrderAnswer")
    },
    {
      question: t("chatbot.questions.addToCart"),
      answer: t("chatbot.questions.addToCartAnswer")
    }
  ];

  return (
    <div className="chatbot-fixed">
      {!open && (
        <button className="chatbot-icon" onClick={() => setOpen(true)} title={t("chatbot.askUs")}>
          💬
        </button>
      )}
      {open && (
        <div className="chatbot-window" style={{ direction: isRTL ? "rtl" : "ltr" }}>
          <div className="chatbot-header">
            <span style={{ textAlign: isRTL ? "right" : "left" }}>{t("chatbot.title")}</span>
            <button className="chatbot-close" onClick={() => { setOpen(false); setSelected(null); }}>×</button>
          </div>
          <div className="chatbot-body">
            {!selected ? (
              <ul className="chatbot-faq-list">
                {faqData.map((item, idx) => (
                  <li key={idx}>
                    <button 
                      className="chatbot-question" 
                      onClick={() => setSelected(item)}
                      style={{ textAlign: isRTL ? "right" : "left" }}
                    >
                      {item.question}
                    </button>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="chatbot-answer-block" style={{ alignItems: isRTL ? "flex-end" : "flex-start" }}>
                <div className="chatbot-question-selected" style={{ textAlign: isRTL ? "right" : "left", width: "100%" }}>
                  {selected.question}
                </div>
                <div className="chatbot-answer" style={{ textAlign: isRTL ? "right" : "left", width: "100%" }}>
                  {selected.answer}
                </div>
                <button 
                  className="chatbot-back" 
                  onClick={() => setSelected(null)}
                  style={{ alignSelf: isRTL ? "flex-start" : "flex-end" }}
                >
                  {t("chatbot.backToQuestions")}
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatBot; 